<template>
  <ul class="list-group category_items"
      v-bind:class="'category_items'+ [isJpTemplate ? '_jp' : '_ww']">
    <li
      v-for="category in categories"
      v-bind:key="category.id"
      v-bind:class="[isJpTemplate ? 'list-group-item col-xs-6 col-sm-6 col-md-3' : 'list-group-item col-xs-12 col-sm-12 col-md-4']"
    >
      <a
        class="category_item"
        v-bind:class="'category_item_' + category.title"
        v-on:click="clickLink(category.title)"
      >
        <div class="category_item_img">
          <img
            v-bind:src="app_root + '/assets/common/img/categries/top_category_' + category.title + '.jpg'"
            v-bind:alt="category.title"
          />
        </div>
        <div class="category_item_text">
          <p class="category_item_title">
            <span>
              <LabelFunMessage
                v-bind:fcontId="getLabelId(category)"
                v-bind:msgkey="getLabelKey(category)"
              />
            </span>
          </p>
        </div>
      </a>
    </li>
  </ul>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import LabelFunMessage from "./LabelFunMessage";

export default {
  name: "CategoryTiles",
  components: {
    LabelFunMessage,
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  computed: {
    ...mapState(["categories","lg2"]),
    ...mapGetters(["isJpTemplate"])
  },
  methods: {
    getLabelId: function (category) {
      return category.label.split("-")[0];
    },
    getLabelKey: function (category) {
      return category.label.split("-")[1];
    },
    clickLink: function (categoryTitle) {
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "category_top",
        "custom_parameter2": categoryTitle
      })

      this.$router.push({ 
        path: '/' + this.lg2 + '/categories/' + categoryTitle,
        query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale } 
      })
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.category_items {
  margin-top: 25px;
  margin-bottom: 15px;
  display: flex;
  flex-wrap: wrap;
  list-style: none;
}

.list-group-item {
  padding: 0;
  margin-bottom: -1px;
  margin-right: -1px;
  border-radius: 0px;
  border: 1px solid #ddd;
}

.category_item {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  padding: 10px 10px;
}

.category_item_img {
  width: 80px;
  height: auto;
  margin: 0;
  border-radius: 50%;
}
.category_item_img img {
  border-radius: 50%;
  transition: 0.2s;
  width: 80px;
}
.category_item_text {
  flex: 1;
  padding: 0 0 0 20px;
  height: 100%;
}
.category_item_title {
  box-sizing: border-box;
  font-size: 16px;
  color: black;
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  border-radius: 4px 0 0 4px;
}

/* hover */
a.category_item:hover .category_item_title {
  text-decoration: underline;
}
a.category_item:hover .category_item_img img {
  opacity: 0.5;
}

/* background-color */
.category_item_special-editions .category_item_img {
  background-color: rgba(68, 142, 111, 1);
}
.category_item_photo-projects .category_item_img {
  background-color: rgba(206, 113, 164, 1);
}
.category_item_gifts .category_item_img {
  background-color: rgba(201, 160, 58, 1);
}
.category_item_interior-decorations-and-sundries .category_item_img {
  background-color: rgba(75, 166, 209, 1);
}
.category_item_hospitality .category_item_img {
  background-color: rgba(191, 144, 0, 1);
}
.category_item_kids .category_item_img {
  background-color: rgba(55, 125, 209, 1);
}
.category_item_seasonal-events .category_item_img {
  background-color: rgba(150, 58, 58, 1);
}

@media screen and (max-width: 767px) {
  .category_item_title span {
    padding: 5px 0px;
    font-size: 14px;
  }
  .category_item {
    padding: 5px 5px;
  }
  .category_item_img {
    width: 50px;
    height: auto;
    margin: 0 auto;
  }
  .category_item_text {
    padding: 0 0 0 15px;
  }
}

/* xs,smのとき */
@media screen and (max-width: 991px) {
  /* 四隅の丸み設定 category_itemsとしてみたときの四隅になるところのみradius=4pxにする */

  /* JPのとき */
  .category_items_jp .list-group-item:first-child {
    border-top-left-radius: 4px;
  }
  .category_items_jp .list-group-item:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .category_items_jp .list-group-item:nth-child(2) {
    border-top-right-radius: 4px;
  }
  .category_items_jp .list-group-item:nth-child(6) {
    border-bottom-right-radius: 4px;
  }

  /* WWのとき */
  .category_items_ww .list-group-item:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  .category_items_ww .list-group-item:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
/* md以上のとき */
@media screen and (min-width: 992px) {
  /* 四隅の丸み設定 category_itemsとしてみたときの四隅になるところのみradius=4pxにする */

  /* JPのとき */
  .category_items_jp .list-group-item:first-child {
    border-top-left-radius: 4px;
  }
  .category_items_jp .list-group-item:last-child {
    border-bottom-right-radius: 4px;
  }
  .category_items_jp .list-group-item:nth-child(4) {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .category_items_jp .list-group-item:nth-child(5) {
    border-bottom-left-radius: 4px;
  }

  /* WWのとき */
  .category_items_ww .list-group-item:first-child {
    border-top-left-radius: 4px;
  }
  .category_items_ww .list-group-item:last-child {
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .category_items_ww .list-group-item:nth-child(3) {
    border-top-right-radius: 4px;
  }
  .category_items_ww .list-group-item:nth-child(6) {
    border-bottom-right-radius: 4px;
  }
}
</style>
